import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import preval from 'preval.macro';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

if (process.env.NODE_ENV === 'production') {
    // build的時間
    const buildDate = preval`module.exports = new Date().toLocaleString();`;
    console.log('buildDate:' + buildDate);
    // build的版本
    console.log('version:' + process.env.version);
    // if (!/log=true/.test(window.location)) {
    //     // 移除一般log
    //     console.log = () => {};
    //     console.info = () => {};
    //     // console.warn = () => {};
    // }
}
